import { createSlice } from '@reduxjs/toolkit';

export const SgsstSlice = createSlice({
    name: 'sgsst',
    initialState: {
        sgsst_list: [],
        sgsst_list_select: []
    },
    reducers: {
        setSgsstRedux: ( state, { payload } ) => {
            state.sgsst_list  =  payload;
        },
        setSgsstSelectRedux: ( state, { payload } ) => {
            state.sgsst_list_select  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setSgsstRedux, setSgsstSelectRedux } = SgsstSlice.actions;